/**
 * App-icon badge (Badging API) — puts the unread-message count on the
 * home-screen icon, same as a native app. Supported on an installed PWA:
 * iOS/iPadOS 16.4+ (after "Add to Home Screen"), Android Chrome, and desktop
 * Chromium/Edge (taskbar/dock icon). No-ops silently everywhere else —
 * including plain browser tabs, where no browser exposes this API.
 */

// The Badging API isn't in every TS lib.dom yet; declare it defensively rather
// than assuming — if a future TS version already has it, this just merges.
declare global {
  interface Navigator {
    setAppBadge?(contents?: number): Promise<void>;
    clearAppBadge?(): Promise<void>;
  }
}

export function isBadgingSupported(): boolean {
  return typeof navigator !== "undefined" && typeof navigator.setAppBadge === "function";
}

/** Set the icon badge to `count`, or clear it entirely at 0. */
export async function setBadgeCount(count: number): Promise<void> {
  if (!isBadgingSupported()) return;
  try {
    if (count > 0) await navigator.setAppBadge!(count);
    else await navigator.clearAppBadge!();
  } catch {
    /* best-effort — a failed badge update is never worth surfacing to the user */
  }
}
